import styled from "@emotion/styled";
import { TopNavProps } from "./TopNav.types";
import { generateTopNavStyles } from "../../utils";
import { colorGuide, colorPalette } from "../../theme/colors";
import { TOP_NAV_Z_INDEX } from "../../utils/constants";

export const TopNavContainer = styled.div<
  TopNavProps & {
    showBackArrow?: boolean;
    isSupportIconVisible?: boolean;
    bgColor?: string;
    sticky?: boolean;
    isWebview?: boolean;
  }
>`
  width: 100%;
  height: ${(props) => (props.isWebview ? "60px" : "84px")};
  display: flex;
  box-sizing: border-box;
  flex-shrink: 0;
  gap: 10px;
  position: ${(props) => (props.sticky ? "none" : "sticky")};
  top: calc(var(--download-nudge-height, 0px));
  background-color: ${(props) =>
    props.bgColor
      ? props.bgColor
      : colorGuide.lightComponents.topNav.background};
  z-index: ${TOP_NAV_Z_INDEX};
  ${(props) => generateTopNavStyles(props)};
  transition: box-shadow 0.3s ease;
`;
export const NavContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const NavArrowWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const NavTextWrapper = styled.div<{ showBackArrow?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`;

export const StyledNavIcon = styled.i<{ color?: string }>`
  font-size: 24px;
  color: ${(props) =>
    props.color ? props.color : colorPalette.popOrange[500]};
  // color: ${colorPalette.popOrange[500]};
  cursor: pointer;
`;

export const NavIcon = styled.i<{ color?: string }>`
  font-size: 12px;
  color: ${(props) =>
    props.color ? props.color : colorGuide.lightComponents.topNav.iconColor};
  // color: ${() => colorGuide.lightComponents.topNav.iconColor};
  cursor: pointer;
`;
export const NavIconContainer = styled.div`
  display: flex;
  padding: 4px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

export const SupportIconWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
`;

export const SupportIconContainer = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  flex-direction: column;
  justify-content: center;
`;
export const SupportIcon = styled.i`
  font-size: 16px;
  color: ${(props) =>
    props.color ? props.color : colorGuide.lightComponents.topNav.iconColor};
  cursor: pointer;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
